module.exports = __webpack_public_path__ + "static/media/filling-brown.a3d13b93.png";